<div class="singlerow">
  <div class="material-scope" *ngIf="uiConfig.marketDropdown.show">
    <mat-form-field>
      <mat-label>{{ labels.market }}</mat-label>
      <mat-select [(ngModel)]="selectedMarket" (selectionChange)="getEngine()">
        <mat-option *ngIf="uiConfig.marketDropdown.enableSearch">
          <ngx-mat-select-search
            [placeholderLabel]="uiConfig.marketDropdown.searchPlaceholder || 'Search'"
            [noEntriesFoundLabel]="uiConfig.marketDropdown.noEntriesFoundLabel || 'No entries found'"
            ngModel
            (ngModelChange)="filterMarketSelection($any($event))"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let item of filteredMarket" [value]="item">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="material-scope" *ngIf="uiConfig.engineDropdown.show">
    <mat-form-field>
      <mat-label>{{ labels.engine }}</mat-label>
      <mat-select [(ngModel)]="selectedEngine" (selectionChange)="onEngineChange()">
        <mat-option>
          <ngx-mat-select-search
            [placeholderLabel]="uiConfig.engineDropdown.searchPlaceholder"
            [noEntriesFoundLabel]="uiConfig.engineDropdown.noEntriesFoundLabel"
            ngModel
            (ngModelChange)="filterEngineSelection($any($event))"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let item of filteredEngines" [value]="item">
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="material-scope" *ngIf="uiConfig.quarterDropdown.show">
    <mat-form-field>
      <mat-label>{{ labels.quarter }}</mat-label>
      <mat-select [(ngModel)]="selectedQuarter" (selectionChange)="onQuarterChange()">
        <mat-option *ngIf="uiConfig.quarterDropdown.enableSearch">
          <ngx-mat-select-search
            [placeholderLabel]="uiConfig.quarterDropdown.searchPlaceholder || 'Search'"
            [noEntriesFoundLabel]="uiConfig.quarterDropdown.noEntriesFoundLabel || 'No entries found'"
            ngModel
            (ngModelChange)="filterQuarterSelection($any($event))"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let item of filteredQuarterOptions" [value]="item">
          {{ item | uppercase }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <table class="legend-table" *ngIf="legendRows?.length">
    <tr *ngFor="let row of legendRows">
      <td class="legend-cell" *ngFor="let cell of row">
        <strong>{{ cell.score }}</strong> - {{ cell.text }}
      </td>
    </tr>
  </table>
</div>

<div class="table-container">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%">
    <ng-container matColumnDef="product">
      <th mat-header-cell *matHeaderCellDef>{{ labels.product }}</th>
      <td mat-cell *matCellDef="let element">{{ element?.[mapping.productField] }}</td>
      <td mat-footer-cell *matFooterCellDef>{{ labels.avgScore }}</td>
    </ng-container>

    <ng-container matColumnDef="keycompetitor">
      <th mat-header-cell *matHeaderCellDef>{{ labels.keyCompetitor }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element?.[mapping.competitorSourceField] }}
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef>{{ labels.user }}</th>
      <td mat-cell *matCellDef="let element">{{ element?.[mapping.emailField] }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container *ngFor="let col of scoreColumns" [matColumnDef]="col.columnId">
      <th mat-header-cell *matHeaderCellDef>
        <div style="display: flex; justify-content: space-around; align-items: center;">
          {{ col.label }}
          <mat-icon class="info-icon" [matTooltip]="getToolTip(col.tooltipKey)">help</mat-icon>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <input
          *ngIf="uiConfig.editableScores; else readonlyScore"
          class="scoreInput"
          matInput
          type="number"
          [(ngModel)]="element[col.dataKey]"
          [min]="1"
          [max]="10"
          (ngModelChange)="calculateAverages()"
        />
        <ng-template #readonlyScore>{{ element?.[col.dataKey] }}</ng-template>
      </td>
      <td class="text-right" mat-footer-cell *matFooterCellDef>
        {{ averageValues[col.dataKey] | number : "1.1-1" }}
      </td>
    </ng-container>

    <ng-container *ngFor="let col of genericColumns" [matColumnDef]="col.columnId">
      <th mat-header-cell *matHeaderCellDef>{{ col.label }}</th>
      <td mat-cell *matCellDef="let element">{{ element?.[col.dataKey] }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef>{{ labels.notes }}</th>
      <td mat-cell *matCellDef="let element">{{ element?.[mapping.notesField] }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td class="delete-cell" mat-cell *matCellDef="let element; let i = index">
        <button mat-icon-button color="warn" class="audit-delete-button" (click)="deleteRow(i)" aria-label="Delete row">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
  </table>
</div>

<div class="lower-container">
  <button class="btn" *ngIf="uiConfig.resetButton.show" (click)="exportAvgScores()">
    Export Avg Scores
  </button>
  <button class="btn" *ngIf="uiConfig.exportButton.show" (click)="exportQuarterData()">
    {{ uiConfig.exportButton.label || uiConfig.saveButton.label || 'Export Quarter Data' }}
  </button>
  <button class="btn" *ngIf="uiConfig.saveButton.show" (click)="saveData()">
    {{ uiConfig.saveButton.label || 'Save' }}
  </button>
</div>
